import React from 'react';
import vars from '../../../vars.module.scss';
import styles from './Logo.module.scss';
import { Box } from '@mui/material';
import { ReactComponent as CdeLogo } from './cde_logo.svg';
import { ReactComponent as CdeBrand } from './cde_brand.svg';

// TODO: Adjust CdeBrand width to 236px. Current problem: The Client shows the current width + 8px.

/**
 * Cosmetic component that shows the CDE logo and brand.
 */
export default () => {
    const color = vars.logoBlue;

    return (
        <Box className={styles.box}>
            <CdeLogo fill={color} />
            <CdeBrand
                fill={color ?? vars.logoBlue}
                style={{ paddingLeft: '8px', width: '228px' }}
            />
        </Box>
    );
};
